import { Neo } from "@singularsystems/neo-react";
import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { ReportCategory } from "../ReportCategory";
import IssuerDividendCriteria from "./IssuerDividendCriteria";
import { DataCacheEntry } from "@singularsystems/neo-core/dist/Data";
import Entity from "../../../Domain/Models/Catalogue/Investments/Entity";

@NeoReport("IssuerDividend", { category: ReportCategory.IssuerReports })
export default class IssuerDividendReport extends Report<IssuerDividendCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(IssuerDividendCriteria);
    }

    public renderCriteria() {
         return IssuerDividendReport.renderReportCriteria(this.criteria, this.dataCache.entities);
    }

    public static renderReportCriteria(criteria: IssuerDividendCriteria, entities: DataCacheEntry<Entity[]>) {
        return <div>
            <DateSelectionComponent criteria={criteria} />
            <Neo.GridLayout md={2}>
                <div>
                    <Neo.FormGroup bind={criteria.meta.entityId} select={{itemSource: entities}} />
                </div>
            </Neo.GridLayout>
        </div>;
    }
}